import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput, CheckBoxInput, SwitchInput } from '../../../Form';
import moment from 'moment';
import ReactDropzone from 'react-dropzone';
import { BASE_URL } from '../../../../config';
import { token } from '../../../../libs/localStorage';
import request from 'superagent';

@inject('stationStore', 'surveyStore', 'surveyTopicStore', 'surveyTemplateStore', 'userStore', 'ticketStore', 'workOrderStore')
@observer
class SurveyCreate extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  slug = 'monitoring/survey/create'

  @observable item = {
    id: '',
    date_visited: '',
    station_id: '',
    survey_template_id: '',
    visitor_user_id: '',
    ticket_id: '',
    work_order_id: '',
    creator_user_id: '',
  };
  @observable topicResponse = [];
  @observable images = [];
  @observable selectedImage = 0;
  @observable isSaving = false;
  @observable editMode = false;
  @observable mounted = false;
  @observable showArchivedTickets = false;
  @observable showArchivedWorkOrders = false;

  state = {
    images: [],
    metaDataId: []
  }

  componentWillMount() {
    const { surveyStore, stationStore, surveyTemplateStore, surveyTopicStore, userStore, ticketStore, workOrderStore, params: { id } } = this.props;
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!surveyTemplateStore.isLoading && !surveyTemplateStore.items.length) surveyTemplateStore.fetchItems();
    if (!surveyTopicStore.isLoading && !surveyTopicStore.items.length) surveyTopicStore.fetchItems();
    if (!userStore.isLoading && !userStore.items.length) userStore.fetchItems();
    if (!ticketStore.isLoading && !ticketStore.items.length) ticketStore.fetchItems();
    if (!workOrderStore.isLoading && !workOrderStore.items.length) workOrderStore.fetchItems();
    if (id) {
      this.editMode = true;
      this.mounted = true;
      this.populate(id);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }


  populate = (id, count = 0) => {
    const { surveyStore, surveyTemplateStore, surveyTopicStore } = this.props;
    if ((!surveyTemplateStore.items.length || !surveyTopicStore.items.length) && count < 120 && this.mounted) {
      setTimeout(() => {
        this.populate(id, count + 1);
      }, 1000);
    } else {
      surveyStore.fetchItem(id, true).then(res => {
        if (!!res && !!res.length) {
          this.item = {
            id: res[0].id,
            date_visited: res[0].date_visited.split('T')[0],
            station_id: res[0].station_id,
            survey_template_id: res[0].survey_template_id,
            visitor_user_id: res[0].visitor_user_id,
            ticket_id: +res[0].ticket_id,
            work_order_id: +res[0].work_order_id,
            creator_user_id: res[0].creator_user_id,
          };
          let template = surveyTemplateStore.findById(res[0].survey_template_id);
          this.topicResponse = template.topics.sort((a, b) => a.seq < b.seq ? -1 : 1).map(item => {
            let response = (res[0].responses || []).find(response => +response.topic_id === +item.topic_id);
            return ({
              topic_id: item.topic_id,
              required: +item.required === 1,
              value: !!response ? response.value : '',
            })
          })
        }
      });
    }
  }

  @action onChange = (e, field) => {
    this.item[field] = e.target.value

    if (field == "station_id") {
      this.setMetaData()
    }

  };

  clearSurvey = () => {
    this.item = {
      date_visited: '',
      station_id: '',
      survey_template_id: '',
      visitor_user_id: '',
      ticket_id: '',
      work_order_id: '',
    };
    this.topicResponse = [];
    this.selectedImage = 0;
    this.setState({ images: [] });
  }

  uploadImage = () => new Promise((resolve, reject) => {
    const url = `${BASE_URL}/idaq/api/upload-manual?imagesource_id=41&station_id=${this.item.station_id}`;
    const req = request.post(url).set('Authorization', `Bearer ${token.getEncoded()}`);

    this.state.images.forEach(image => {
      req.attach('images', image);
    });

    req.end((err, res) => {
      if (err) reject(err);
      else resolve(res);
    })
  })

  handleSave = (e) => {
    e.preventDefault();
    const { surveyStore } = this.props;
    const { notify, router } = this.context;

    const formFilled =
      (() => ['date_visited', 'station_id', 'survey_template_id', 'visitor_user_id'].reduce((acc, key) => acc && this.item[key] !== '', true))() &&
      (() => this.topicResponse.reduce((acc, item) => acc && (item.required ? item.value !== '' : true), true))();

    if (!formFilled) {
      notify.error({ message: 'Missing Fields' });
      return
    }

    this.isSaving = true;

    if (this.editMode) {
      let payload = Object.assign({}, toJS(this.item), {
        responses: this.topicResponse.map(({ topic_id, value }) => ({ topic_id, value })),
      });
      surveyStore.updateItem(payload)
        .then(() => {
          this.isSaving = false;
          notify.success({ message: 'Success' });
          router.push('monitoring/survey/history');
        })
        .catch(err => {
          this.isSaving = false;
          console.log(err);
          notify.error(err);
        });
    } else {
    if (this.state.images.length > 0) {
      this.uploadImage()
        .then(images => {
          let payload = Object.assign({}, toJS(this.item), {
            date_visited: moment(this.item.date_visited).format('YYYY-MM-DDT00:00:00'),
            responses: this.topicResponse.map(({ topic_id, value }) => ({ topic_id, value })),
            images: images.body.map(item => ({
              file_name: item.file_name,
              file_location: item.folder_path
            }))
          });
          surveyStore.createItem(payload)
            .then(() => {
              this.isSaving = false;
              this.clearSurvey();
              notify.success({ message: 'Success' });
            })
            .catch(err => {
              this.isSaving = false;
              console.log(err);
              notify.error(err);
            });
        })
        .catch(err => {
          this.isSaving = false;
          console.log(err);
          notify.error({ message: 'Failed to upload image' });
        }); 
    } 
     else {
        let payload = Object.assign({}, toJS(this.item), {
          date_visited: moment(this.item.date_visited).format('YYYY-MM-DDT00:00:00'),
          responses: this.topicResponse.map(({ topic_id, value }) => ({ topic_id, value })),
        });
        surveyStore.createItem(payload)
          .then(() => {
            this.isSaving = false;
            this.clearSurvey();
            notify.success({ message: 'Success' });
          })
          .catch(err => {
            this.isSaving = false;
            console.log(err);
            notify.error(err);
          });
     }
    }
  }


  resetTopicResponse = () => {
    const { surveyTemplateStore, surveyTopicStore, stationStore } = this.props;
    const selectedStation = stationStore.items.find(station => station.id === this.item.station_id);

    if (!this.item.survey_template_id) {
      this.topicResponse = [];
      return;
    }
    let template = surveyTemplateStore.findById(this.item.survey_template_id);
    this.topicResponse = !template ? [] : template.topics.sort((a, b) => a.seq < b.seq ? -1 : 1).map(item => {
      let topic = surveyTopicStore.findById(item.topic_id)

      return ({
        topic_id: item.topic_id,
        required: +item.required === 1,
        value: topic.type === 2 ? 0 : '',
      })
    })

    this.setMetaData()
  }


  setMetaData = () => {
    if (!this.item.survey_template_id || !this.item.station_id) return;
    const { surveyTopicStore, stationStore } = this.props;

    const selectedStation = stationStore.items.find(station => +station.id === +this.item.station_id);

    let topicResponse = this.topicResponse.map(item => {
      let topic = surveyTopicStore.findById(item.topic_id)
      if (topic.type !== 6) return item;

      const meta_data_id = topic.options[0].value;
      const matchingMetaData = meta_data_id < 0 ?
        {
          value: (() => {
            switch (+meta_data_id) {
              case -1: return selectedStation.name;
              case -2: return selectedStation.descrpition;
              case -3: return selectedStation.latitude;
              case -4: return selectedStation.longitude;
              case -5: return selectedStation.elevation;
              case -6: return selectedStation.id;
              case -7: return selectedStation.identifier;
              default: return '';
            }
          })()
        }
        : selectedStation.meta_data.find(meta => meta.id === meta_data_id);
      item.value = !!matchingMetaData && !!matchingMetaData.value ? matchingMetaData.value : '';
      return item;
    })

    this.topicResponse = topicResponse;
  }

  onAddPicture = files => {
    if (this.state.images.length >= 3) {
      this.context.notify.error({ message: 'Images limit reached.' });
      return;
    }
    this.setState({ images: [...this.state.images, ...files] })
  }

  _renderSurveyQuestionare = () => {
    const { surveyTopicStore, stationStore } = this.props;

    if (!this.topicResponse.length) return;
    return (
      <div className='container bordered indented-form'>
        {this.topicResponse.map(item => {
          let topic = surveyTopicStore.findById(item.topic_id)
          if (topic.type === 1 || topic.type === 6) return <TextInput label={topic.name + (item.required ? ' *' : '')} value={item.value} onChange={e => item.value = e.target.value} key={`topic-${item.topic_id}`} />
          if (topic.type === 2) return <CheckBoxInput label={topic.name + (item.required ? ' *' : '')} checked={+item.value === 1} onChange={e => item.value = ~item.value + 2} key={`topic-${item.topic_id}`} />
          if (topic.type === 3) return <SelectInput label={topic.name + (item.required ? ' *' : '')} options={topic.options} fields={{ label: 'value', value: 'value' }} value={item.value} onChange={e => item.value = e.target.value} key={`topic-${item.topic_id}`} />
          if (topic.type === 4) return <DateInput label={topic.name + (item.required ? ' *' : '')} value={item.value} onChange={e => item.value = e.target.value} key={`topic-${item.topic_id}`} />
          if (topic.type === 5) return <DateInput type='time' label={topic.name + (item.required ? ' *' : '')} value={item.value} onChange={e => item.value = e.target.value} key={`topic-${item.topic_id}`} />
        })}
      </div>
    )
  }

  _renderImages = () => {
    return <div className='survey-image-container'>
      <ReactDropzone ref="dropzone" onDrop={this.onAddPicture} style={{ border: 'none', width: 'fit-content', height: 'unset' }} >
        <span className='button'>Add Picture</span>
      </ReactDropzone>
      <div className='station-image-slider'>
        {this.state.images.length > 1 && <div className='station-image-slide-selector'>
          {this.state.images.map((image, i) => (
            <div key={i} className={`image-slide-item ${this.selectedImage === i ? 'image-slide-active' : ''}`} onClick={() => this.selectedImage = i} >
              {/* <img id={image.name} src={`${BASE_URL}/images/${image.name}`} style={{ width: '100%' }} alt='not-found' /> */}
              <div style={{
                height: '100px',
                width: '100px',
                backgroundImage: `url(${image.preview})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                borderRadius: '12px',
              }} alt='not-found' />
            </div>
          ))}
        </div>}
        {this.state.images.length > 0 && <div className="imageContainer full-width">
          <div className="imageRemove"><span className="fa fa-remove" onClick={() => { this.setState({ images: this.state.images.filter(item => item.name !== this.state.images[this.selectedImage].name) }); this.selectedImage = 0; }} /></div>
          <img src={this.state.images[this.selectedImage].preview} style={{ width: '100%' }} alt='not-found' />
        </div>}
      </div>
    </div>
  }

  render() {
    const { stationStore, surveyTemplateStore, surveyTopicStore, userStore, ticketStore, workOrderStore, children } = this.props;

    let isLoading = surveyTemplateStore.isLoading || stationStore.isLoading || surveyTopicStore.isLoading || userStore.isLoading || workOrderStore.isLoading || this.isSaving;
    if (isLoading) return <Spinner />;

    return (
      <div>
        <div className='inline-grid space-between overflow-x-hidden'>
          <div className='flex-grow'>
            <Form>
              <FormBody>
                <div className='inline-grid'>
                  <div>
                    <SelectInput label={'Station'} value={this.item.station_id} fields={{ label: 'name', value: 'id' }} options={stationStore.items} onChange={e => this.onChange(e, 'station_id')} filterOptions={stationStore.filterStations} />
                    <SelectInput label={'Visited By'} value={this.item.visitor_user_id} fields={{ label: 'name', value: 'id' }} options={userStore.items} onChange={e => this.onChange(e, 'visitor_user_id')} />
                    <DateInput label={'Date Visited'} value={this.item.date_visited} onChange={e => this.onChange(e, 'date_visited')} />
                    <SelectInput label={'Template'} value={this.item.survey_template_id} fields={{ label: 'name', value: 'id' }} options={surveyTemplateStore.items} onChange={e => { this.onChange(e, 'survey_template_id'); this.resetTopicResponse(); }} />
                  </div>
                  <div>
                    {this.item.station_id !== '' &&
                      <SwitchInput label={"Show archived tickets"} value={this.showArchivedTickets} onChange={e => this.showArchivedTickets = !this.showArchivedTickets} />
                    }
                    {this.item.station_id !== '' &&
                      <SwitchInput label={"Show archived workorder"} value={this.showArchivedWorkOrders} onChange={e => this.showArchivedWorkOrders = !this.showArchivedWorkOrders} />
                    }
                    {this.item.station_id !== '' &&
                      <SelectInput label={'Ticket'}
                        value={this.item.ticket_id}
                        fields={{ label: 'summary', value: 'id' }}
                        options={ticketStore.items.filter(item => +item.station_id === +this.item.station_id && (this.showArchivedTickets ? true : !item.archived))}
                        onChange={e => this.onChange(e, 'ticket_id')}
                      />}
                    {this.item.station_id !== '' &&
                      <SelectInput label={'Work Order'}
                        value={this.item.work_order_id}
                        fields={{ label: 'title', value: 'id' }}
                        options={workOrderStore.items.filter(item => item.station && (+item.station[0].id === +this.item.station_id) && (this.showArchivedWorkOrders ? true : !item.archived))}
                        onChange={e => this.onChange(e, 'work_order_id')}
                      />}
                  </div>
                </div>

                {this._renderSurveyQuestionare(this.item.survey_template_id)}
              </FormBody>

              <FormActions>
                <button onClick={this.handleSave}>Save</button>
              </FormActions>
            </Form>
          </div>
          {this._renderImages()}
        </div>
        {!!children && React.cloneElement(children, { slug: this.slug })}
      </div>
    );
  }
}

export default SurveyCreate;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/Survey/SurveyCreate.js